import type { CARDS_ASPECT_RATIO } from 'blocks/Cards'

import { styled } from '@linaria/react'
import { COLOR, CORNERS, FIXED_INDENTS, LAYOUT, ROW_GAP } from 'vars/index'

export const SkeletonTitleSC = styled.div``
export const SkeletonSeeAllSC = styled.div``

export const RowSkeletonItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 400ms linear;
`

export const SimpleRowSkeletonItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 400ms linear;
  border-radius: var(${CORNERS.CORNERS_25});
  background:
    var(${COLOR.SKELETON_SHINE_GRADIENT}),
    var(--componentsBGColor, rgba(37, 37, 37, 1));
  background-repeat: repeat-y;
  background-size: 800px 850px;
  background-position: -800px 0;
  animation: shine 1.5s infinite;
  @keyframes shine {
    to {
      background-position: calc(100vw + 1200px) 0;
    }
  }
`

export const RowSkeletonContainerSC = styled.div`
  gap: var(${ROW_GAP.SIZE_10});
  display: flex;
`

export const RowSkeletonTitleSC = styled.div`
  display: flex;
  width: 100%;
  height: 32px;

  ${SkeletonTitleSC} {
    content: '';
    position: absolute;
    top: 0;
    left: var(${LAYOUT.HorizontalPaddings});
    width: 176px;
    height: 32px;
  }

  ${SkeletonSeeAllSC} {
    content: '';
    position: absolute;
    top: 8px;
    right: var(${LAYOUT.HorizontalPaddings});
    width: 80px;
    height: 32px;
  }
`

export const RowSkeletonInnerSC = styled.div<{
  cardsAspectRatio: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  cardsInRow: number
  verticalPadding?: FIXED_INDENTS
}>`
  --cardWidth: ${({ cardsInRow }) =>
    `calc((100vw - (var(${LAYOUT.HorizontalPaddings}) * 2) - ${cardsInRow} * var(${ROW_GAP.SIZE_10})) / ${cardsInRow})`};
  --heaghtCard: ${({ cardsAspectRatio }) =>
    `calc(var(--cardWidth) / ${cardsAspectRatio})`};
  min-height: calc(var(--heaghtCard) + 32px);
  width: 100%;
  gap: 20px;
  padding-left: var(${LAYOUT.HorizontalPaddings});
  padding-top: ${({ verticalPadding = FIXED_INDENTS.INDENT_0 }) =>
    `var(${verticalPadding})`};
  padding-bottom: ${({ verticalPadding = FIXED_INDENTS.INDENT_0 }) =>
    `var(${verticalPadding})`};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  flex: 0 0;

  ${RowSkeletonItem} {
    flex: 0 0 auto;
    background-color: var(--componentsBGColor);
    width: var(--cardWidth);
    height: var(--heaghtCard);
  }

  ${RowSkeletonTitleSC} {
    &:after,
    &:before {
      background-color: var(--componentsBGColor);
    }
  }
`
